var FragmentNav = {
    $root: null,
    $trigger: null,
    $content: null,
    init: function(selector) {
        if (!$(selector).length) {
            return
        }

        this.$root = $(selector);
        this.$content = this.$root.find('.js-FragmentNavContent');
        this.$tippybottom = $('<svg width="17" height="17" style="top: 3px; position: relative; transition: transform 200ms ease-in;" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.384 12.1L3 5.64L3.768 5L8.384 10.54L13 5L13.768 5.64" fill="currentcolor"/></svg>');
        this.$trigger = $('<button class="Btn  Btn--baselineAdjusted  Btn--outline  c-grey03">Menu</button>')
            .append(this.$tippybottom);

        this.$content.before(this.$trigger);
        this.$content.addClass('is-hidden');

        this.$content.before(this.$tippybottom)

        $(window).on('scroll', this.scrollDisplay.bind(this));
        $(document.body).on('click', this.menuClose.bind(this));
        this.$trigger.on('click', this.menuToggle.bind(this));
        this.$content.on('click', this.menuScrollClick.bind(this));

        this.scrollDisplay();

    },

    menuToggle: function(event) {
        this.$content.hasClass('is-hidden')
            ? this.menuOpen(event) : this.menuClose(event);
        event.preventDefault();
        event.stopPropagation();
    },

    menuOpen: function(event) {
        if (this.$content.hasClass('is-hidden')) {
            this.$content.removeClass('is-hidden');
            this.$tippybottom.css({ 'transform': 'scale(1, -1)' });
        }
    },

    menuClose: function(event) {
        if (!this.$content.hasClass('is-hidden')) {
            this.$content.addClass('is-hidden');
            this.$tippybottom.css({ 'transform': 'scale(1, 1)' });
        }
    },

    menuScrollClick: function(event) {
        var winScroll = $(window).scrollTop();
        var newPosition = $(event.target.hash).offset().top;
        var offset = (winScroll === 0 || winScroll > newPosition) ? 160 : 90;

        $(window).scrollTop(newPosition - offset);
        event.preventDefault();
    },

    scrollDisplay: function() {
        var tolerance = 180;
        var scrollDistance = $(document).scrollTop();
        var $items = $('.js-ScrollStackItem');
        var $trigger = this.$trigger;
        var $content = this.$content;

        $trigger
            .html($content.find('[href="#' + $items[0].id + '"]').text())
            .append(this.$tippybottom);

        $items.each(function(i, v) {
            if (scrollDistance > $(v).offset().top - tolerance) {
                $trigger
                    .html($content.find('[href="#' + v.id + '"]').text())
                    .append(this.$tippybottom);
            }
        }.bind(this))
    }
};

FragmentNav.init('.js-FragmentNav');

